export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_04.12318e63.jpg";